import styled, { keyframes } from 'styled-components';

export const DropdownWrapper = styled.div`
  position: relative;
`;

export const BellButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Badge = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #f43f5e;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 5px;
  border-radius: 9999px;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  right: 0;
  top: 40px;
  width: 350px;
  max-height: 450px;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 1000;
`;

export const ListRoot = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 140px;
`;

export const ListSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 0.15rem 0.7rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
`;

export const SummaryText = styled.span`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const UnreadCount = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.action.primary.bg};
`;

export const ListBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NotificationItem = styled.button`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.85rem;
  margin: 0;
  padding: 1rem 0.65rem 1rem 0.85rem;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 0;
  text-align: left;
  cursor: pointer;
  background: ${({ $selected, theme }) => {
    if (!$selected) return 'transparent';
    return theme.name === 'dark'
      ? 'rgba(62, 207, 142, 0.14)'
      : 'rgba(62, 207, 142, 0.1)';
  }};
  transition: background-color 0.15s ease;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.65rem;
    bottom: 0.65rem;
    width: 3px;
    border-radius: 999px;
    background: ${({ theme, $unread, $selected }) =>
      $unread || $selected ? theme.colors.action.primary.bg : 'transparent'};
    transition: background-color 0.15s ease;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ $selected, theme }) => {
      if ($selected) {
        return theme.name === 'dark'
          ? 'rgba(62, 207, 142, 0.18)'
          : 'rgba(62, 207, 142, 0.14)';
      }
      return theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.03)'
        : theme.colors.borderSubtle;
    }};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.primary.bg};
    outline-offset: -2px;
  }
`;

export const UnreadDot = styled.span`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin-top: ${({ $compact }) => ($compact ? 0 : '0.45rem')};
  border-radius: 50%;
  background: ${({ theme, $unread }) =>
    $unread ? theme.colors.action.primary.bg : theme.colors.borderStrong};
  opacity: ${({ $unread }) => ($unread ? 1 : 0.35)};
`;

export const NotificationContent = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 0.3rem;
`;

export const NotificationTop = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
`;

export const UserBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`;

export const Avatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 0.75rem;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  font-size: 0.8125rem;
  min-width: 0;
`;

export const UserName = styled.span`
  font-size: 0.875rem;
  font-weight: ${({ $unread }) => ($unread ? 600 : 500)};
  color: ${({ theme, $unread }) =>
    $unread ? theme.colors.textPrimary : theme.colors.textSecondary};
  line-height: 1.4;
  letter-spacing: -0.01em;
`;

export const UserEmail = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.35;
`;

export const TimeText = styled.span`
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 500;
  color: ${({ theme, $unread }) =>
    $unread ? theme.colors.textSecondary : theme.colors.textMuted};
  line-height: 1.35;
  white-space: nowrap;
`;

export const OptionsButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const NotificationText = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: ${({ theme, $unread }) =>
    $unread ? theme.colors.textSecondary : theme.colors.textMuted};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.1rem;
`;

export const StatusLabel = styled.span`
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme, $unread }) =>
    $unread ? theme.colors.action.primary.bg : theme.colors.textMuted};
`;

export const ViewMore = styled.div`
  text-align: center;
  padding: 0.5rem 0;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textSecondary};

  &:hover {
    text-decoration: underline;
  }
`;

export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 0.15rem 0.25rem;
  margin-top: 0.15rem;
  border-top: 1px solid ${({ theme }) => theme.colors.borderSubtle};
`;

export const PaginationInfo = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.textMuted};
  white-space: nowrap;
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const PageButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.7rem;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) =>
      theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.04)'
        : theme.colors.borderSubtle};
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.35rem;
  padding: 1.75rem 0.25rem;
`;

export const EmptyMessage = styled.p`
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const EmptyHint = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const shimmer = keyframes`
  0% { opacity: 0.45; }
  50% { opacity: 0.85; }
  100% { opacity: 0.45; }
`;

export const SkeletonItem = styled.div`
  display: flex;
  gap: 0.85rem;
  padding: 1rem 0.65rem 1rem 0.85rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  animation: ${shimmer} 1.4s ease-in-out infinite;

  &:last-child {
    border-bottom: none;
  }
`;

export const SkeletonDot = styled.div`
  width: 8px;
  height: 8px;
  margin-top: 0.45rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.borderStrong};
`;

export const SkeletonLines = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
`;

export const SkeletonLine = styled.div`
  height: ${({ $height }) => $height || '0.75rem'};
  width: ${({ $width }) => $width || '100%'};
  border-radius: 4px;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.08)'
      : theme.colors.borderDefault};
`;

export const DetailOverlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: flex-end;
  background: ${({ theme }) =>
    theme.name === 'dark' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(15, 23, 42, 0.28)'};
  z-index: 1000;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition: opacity 220ms ease;
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const DetailPanel = styled.aside`
  display: flex;
  flex-direction: column;
  width: min(100%, 420px);
  height: 100%;
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? theme.colors.backgroundSecondary
      : theme.colors.background};
  border-left: 1px solid ${({ theme }) => theme.colors.borderDefault};
  box-shadow: -12px 0 32px rgba(15, 23, 42, 0.12);
  transform: translate3d(${({ $open }) => ($open ? '0' : '100%')}, 0, 0);
  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const DetailHeader = styled.header`
  flex-shrink: 0;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderDefault};
`;

export const DetailTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
`;

export const DetailTitle = styled.h2`
  margin: 0;
  font-size: 1rem;
  font-weight: 650;
  letter-spacing: -0.01em;
  line-height: 1.35;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const DetailClose = styled.button`
  margin: 0;
  padding: 0.25rem 0.5rem;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 4px;
  background: transparent;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.65rem;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.textPrimary};
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.primary.bg};
    outline-offset: 2px;
  }
`;

export const DetailMetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  margin-top: 0.55rem;
`;

export const DetailTypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.colors.action.primary.bg};
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(62, 207, 142, 0.16)'
      : 'rgba(62, 207, 142, 0.12)'};
`;

export const DetailTime = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const DetailBody = styled.div`
  flex: 1;
  overflow: auto;
  padding: 0.85rem 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  &::-webkit-scrollbar {
    width: 4px;
  }
`;

export const DetailSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const DetailSectionTitle = styled.h3`
  margin: 0;
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const DetailMessage = styled.p`
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-word;
`;

export const DetailKvList = styled.dl`
  margin: 0;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.4rem 0.85rem;
  font-size: 0.8125rem;
`;

export const DetailKvItem = styled.div`
  display: contents;
`;

export const DetailKvKey = styled.dt`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  font-weight: 500;
`;

export const DetailKvValue = styled.dd`
  margin: 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 600;
`;

export const DetailFooter = styled.div`
  flex-shrink: 0;
  padding: 0.85rem 1rem 1.1rem;
  border-top: 1px solid ${({ theme }) => theme.colors.borderDefault};
`;

export const DetailCta = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 2.5rem;
  padding: 0 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.action.primary.text};
  background: ${({ theme }) => theme.colors.action.primary.bg};
  border: 1px solid ${({ theme }) => theme.colors.action.primary.bg};
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.action.primary.bgHover};
    border-color: ${({ theme }) => theme.colors.action.primary.bgHover};
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.primary.bg};
    outline-offset: 2px;
  }
`;

